/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
  export interface ApiConfigurationScope extends angular.IScope {
    model: models.ApiConfigurationModel
  }

  export class ApiConfigurationController implements IController {
    constructor(
      private scope: ApiConfigurationScope,
      $routeParams: angular.route.IRouteParamsService,
      growlService: angular.growl.IGrowlService,
      processConfigurationService: services.ProcessConfigurationService,
      systemLevelService: services.SystemLevelService,
      apiConfigurationService: services.ApiConfigurationService,
      queryConfigurationService: services.QueryConfigurationService,
      objectQueryService: services.ObjectQueryService,
      deleteService: services.DeleteService,
      apiKeyService:services.ApiKeyService,
      externalApiService: services.ExternalApiService,
      ngAuthSettings: any) {
      var processConfigurationId = $routeParams["id"];

      this.scope.model = new models.ApiConfigurationModel(
        scope,
        growlService,
        processConfigurationId,
        processConfigurationService,
        systemLevelService,
        apiConfigurationService,
        queryConfigurationService,
        objectQueryService,
        deleteService,
        apiKeyService,
        externalApiService,
        ngAuthSettings.apiServiceBaseUri);
    }
  }
}

warsApp.registerController('ApiConfigurationController',
    ['$scope', '$routeParams', 'growl', 'processConfigurationService', 'systemLevelService', 'apiConfigurationService', 'queryConfigurationService',
      'objectQueryService', 'deleteService', 'apiKeyService', 'externalApiService', 'ngAuthSettings']
);